<template>
    <div class="widget">
        <h4 class="widgettitle" style="margin-top: 20px;">{{ amenities_translate }}</h4>
        <div class="background-white p20" style="min-height: 210px;">
            <div class="form-group">
                <div v-for="(amenity, index) in amenities" class="checkbox amenitiesCheckBox">
                    <input type="checkbox" :id="'amenity-'+index+'-'+component_id" :value="amenity.slug"
                           v-model="selected_amenities" @change="emitEvent" style="display: none;">
                    <label :for="'amenity-'+index+'-'+component_id">{{ amenity.name }}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import search from '../search';

export default {
    mixins: [
        search
    ],

    props: {
        amenities_translate: {
            type: String,
            default: 'Amenities'
        },
        auto_complete_route: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            component_id: 0,
            amenities: [],
            selected_amenities: []
        }
    },

    methods: {
        getAmenities() {
            let self = this;

            axios.get(`${this.auto_complete_route}?requested_type=amenities`)
                .then(function (response) {
                    self.amenities = response.data.results;
                })
                .catch(function () {
                    // Do nothing
                });
        },
        setSearchedAmenities() {
            let amenities = this.getUserSearchSessionByType('amenities');

            if (amenities.length > 0) {
                this.selected_amenities = amenities.map(amenity => amenity.value);
                this.emitEvent();
            }
        },
        emitEvent() {
            this.eventHub.$emit('amenity-ticked', this.selected_amenities)
        }
    },

    created() {
        let self = this;

        this.eventHub.$on('reset_amenity', amenity => {
            self.selected_amenities = self.selected_amenities.filter(selected_amenity => selected_amenity !== amenity.value);
            self.emitEvent();
        });
    },

    mounted() {
        this.component_id = this._uid;

        this.getAmenities();
        this.setSearchedAmenities();
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/RestaurantSearchAmenities.vue